import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { WorkspaceService as WorkspaceDataService } from '@app/shared/store/data-services';
import { WorkspaceSelectors } from '@app/shared/store/selectors';
import { WorkspaceService } from '@keeps-platform-frontend-workspace/kp-keeps';
import { FuseConfigService } from '@keeps-platform-frontend-workspace/layout';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-workspace-layout',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  template: `
    <div class="w-full">
      <app-workspace-image-upload></app-workspace-image-upload>
      <kp-color-palette [selectedTheme]="themeColor$ | async" (colorChanged)="colorChanged($event)"></kp-color-palette>
      <h3 class="font-weight-900 mt-6 mb-2">
        {{ 'WORKSPACES.DETAIL.COLOR-PICKER' | transloco }}
      </h3>
      <kp-color-picker [color]="themeColor$ | async" (colorChange)="colorChanged($event)"></kp-color-picker>

      <h3 class="font-weight-900 mt-6 mb-2">
        {{ 'WORKSPACES.DETAIL.DARK-THEME' | transloco }}
      </h3>
      <app-workspace-dark-switch
        [isDarkTheme]="isDarkTheme$ | async"
        (toggled)="toggleDarkTheme($event)"
      ></app-workspace-dark-switch>
    </div>
  `,
})
export class WorkspaceLayoutComponent {
  isDarkTheme$: Observable<boolean | undefined>;
  themeColor$: Observable<string | undefined>;
  private _id: string;

  constructor(
    private store: Store,
    private _workspaceDataService: WorkspaceDataService,
    private workspaceService: WorkspaceService,
    private _fuseConfigService: FuseConfigService,
  ) {
    this._id = this.workspaceService.getCurrentWorkspace().id;
    this.isDarkTheme$ = this.store.select(WorkspaceSelectors.selectIsDarkMode(this._id));
    this.themeColor$ = this.store.select(WorkspaceSelectors.selectCustomColor(this._id));
  }

  colorChanged(custom_color: string) {
    const workspace = this.workspaceService.getCurrentWorkspace();
    this._workspaceDataService.update({ ...workspace, custom_color } as unknown).subscribe((w) => {
      this._fuseConfigService.config = { themeColor: w.custom_color };
      this.workspaceService.setCurrentWorkspace({ ...w } as unknown);
    });
  }

  toggleDarkTheme(theme_dark: boolean): void {
    const workspace = this.workspaceService.getCurrentWorkspace();
    this._workspaceDataService.update({ ...workspace, theme_dark } as unknown).subscribe((w) => {
      this._fuseConfigService.config = { scheme: workspace.theme_dark ? 'dark' : 'light' };
      this.workspaceService.setCurrentWorkspace({ ...w } as unknown);
    });
  }
}
